<template lang="pug">
b-modal(
  v-model="showModal"
  id="parts-modal"
  size="md"
  hide-backdrop-click
  @hide="handleClose"
)
  template(#modal-title)
    span.modal-part-number.d-block {{ selectedItem.part_number || '' }}
    span.modal-part-type.d-block {{ selectedType }}
  template(#default)
    div(v-if="modalLoading" class="text-center my-4")
      Loader
    
    div(v-else-if="!modalLoading && modalData")
      .client-data-section(v-if="allModalOts && allModalOts.length > 0")
        .row-title
          b-icon-tools.section-icon
          h3.section-title Estado: {{selectedType.charAt(0).toUpperCase() + selectedType.slice(1)}}
      
      .modal-table(v-if="allModalOts && allModalOts.length > 0")
        b-table(
          :items="allModalOts"
          :fields="modalTableFields"
          borderless
          small
          responsive
          tbody-tr-class="border-bottom"
        )
        
        // Botón "Cargar más" si hay más datos
      div(v-if="hasMoreOts" class="text-right mt-3")
          p(
            @click="loadMoreOts" 
            variant="outline-primary" 
            size="sm"
            :disabled="loadingMoreOts"
            class="clickable-cell cargar"
          )
            b-spinner(v-if="loadingMoreOts" small class="mr-2")
            span {{ loadingMoreOts ? 'Cargando...' : 'Cargar más' }}
      div(v-else-if="allModalOts && allModalOts.length === 0" class="text-center my-4")
        b-icon(icon="exclamation-triangle" variant="warning" font-scale="2")
        p.mt-2 No hay órdenes de trabajo asociadas a esta pieza en el estado {{selectedType}}.
    
    div(v-else-if="!modalLoading")
      .text-center.my-4
        b-icon(icon="exclamation-triangle" variant="warning" font-scale="2")
        p.mt-2 No se encontraron órdenes de trabajo para esta pieza en el estado {{selectedType}}.
  
  template(#modal-footer)
    .d-flex.justify-content-between(style="width: 100%;")
      b-button(@click="exportModalToExcel" variant="secondary" size="sm" :disabled="exportingExcel" class="btn-export")
        b-spinner(v-if="exportingExcel" small class="mr-2")
        b-icon(v-else icon="box-arrow-right")
        span {{ exportingExcel ? 'Exportando...' : 'Exportar a Excel' }}
      b-button(@click="closeModal" variant="primary" size="sm" class="btn-close-modal") Cerrar
</template>

<script>
import * as XLSX from 'xlsx'
import { mapActions } from 'vuex'
import Loader from '../UI/Loader.vue'

export default {
  name: 'PartsModal',
  components: {
    Loader,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Object,
      default: () => ({})
    },
    selectedType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false,
      modalLoading: false,
      modalData: null,
      allModalOts: [],
      hasMoreOts: false,
      loadingMoreOts: false,
      currentOtPage: 1,
      exportingExcel: false,
      otPageSize: 5,
      modalTableFields: [
        { 
          key: 'numero_ot', 
          label: 'N° de OT', 
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
          thStyle: { width: '25%' }
        },
        { 
          key: 'cantidad', 
          label: 'Cantidad', 
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '25%' }
        },
        { 
          key: 'ultimo_usuario_modificacion', 
          label: 'Último movimiento', 
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right',
          thStyle: { width: '50%' }
        },
      ],
    }
  },
  watch: {
    visible(newVal) {
      this.showModal = newVal
      if (newVal) {
        this.loadModalData()
      }
    },
    showModal(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  methods: {
    ...mapActions('Diagnosticos', ['PartsInOTbyState']),
    
    async loadModalData() {
      if (!this.selectedItem.part_number || !this.selectedType) return
      
      this.modalLoading = true
      this.currentOtPage = 1
      this.allModalOts = []
      this.hasMoreOts = false
      
      // Mapear el tipo al estado esperado por la API
      const estadoMap = {
        'allocated': 'allocated',
        'drop': 'drop', 
        'malos': 'bad'
      }
      
      try {
        const response = await this.PartsInOTbyState({
          partNumber: this.selectedItem.part_number,
          state: estadoMap[this.selectedType],
          page: 1,
          pageSize: this.otPageSize,
        })
        
        console.log('Response from API:', response)
        
        // La API devuelve una estructura paginada: { part_number, descripcion_parte, ..., results: [...] }
        this.modalData = response
        this.allModalOts = response.results || []
        
        console.log('Modal data:', this.modalData)
        console.log('All modal OTs:', this.allModalOts)
        console.log('Final allModalOTs length:', this.allModalOts.length)
        
        // Verificar si hay más páginas usando la paginación de DRF
        this.hasMoreOts = !!response.next
        
        console.log('Has next page:', !!response.next)
        
      } catch (error) {
        console.error('Error al obtener datos de OT:', error)
        this.modalData = null
        this.allModalOts = []
        this.hasMoreOts = false
      } finally {
        this.modalLoading = false
      }
    },
    
    async loadMoreOts() {
      if (this.loadingMoreOts || !this.hasMoreOts) return
      
      this.loadingMoreOts = true
      this.currentOtPage += 1
      
      // Mapear el tipo al estado esperado por la API
      const estadoMap = {
        'allocated': 'allocated',
        'drop': 'drop', 
        'malos': 'bad'
      }
      
      try {
        const response = await this.PartsInOTbyState({
          partNumber: this.selectedItem.part_number,
          state: estadoMap[this.selectedType],
          page: this.currentOtPage,
          pageSize: this.otPageSize,
        })
        
        // Agregar nuevos elementos a la lista existente
        const newOtsData = response.results || []
        
        if (newOtsData && newOtsData.length > 0) {
          this.allModalOts = [...this.allModalOts, ...newOtsData]
        }
        
        // Verificar si hay más páginas usando la paginación de DRF
        this.hasMoreOts = !!response.next
        
      } catch (error) {
        console.error('Error al cargar más OTs:', error)
        // Revertir página si hay error
        this.currentOtPage -= 1
      } finally {
        this.loadingMoreOts = false
      }
    },
    
    exportModalToExcel() {
      if (!this.modalData || !this.allModalOts || this.allModalOts.length === 0) {
        this.$bvToast.toast('No hay datos para exportar', {
          title: 'Información',
          variant: 'warning',
          solid: true
        })
        return
      }

      this.exportingExcel = true

      try {
        // Crear un nuevo workbook
        const wb = XLSX.utils.book_new()
        
        // Datos del resumen (usando modalData que ahora contiene results)
        const summaryData = [
          ['Part Number', this.modalData.part_number],
          ['Estado', this.modalData.estado_consultado],
          ['Cantidad total en estado', this.modalData.cantidad_total_en_estado],
          ['Total OTs encontradas', this.modalData.total_ots_encontradas],
          [], // Línea vacía
          ['Detalles de Órdenes de Trabajo'], // Título de la tabla
          []
        ]

        // Headers de la tabla de OTs
        const headers = ['N° de OT', 'Cantidad', 'Estado Parte', 'Allocated', 'Fecha Solicitud', 'Fecha Entrega', 'Último Usuario Modificación']
        
        // Datos de la tabla de OTs (usando todos los datos cargados)
        const tableData = this.allModalOts.map(ot => [
          ot.numero_ot || '',
          ot.cantidad || 0,
          ot.estado_parte || '',
          ot.allocated ? 'Sí' : 'No',
          ot.fecha_solicitud ? new Date(ot.fecha_solicitud).toLocaleDateString() : '',
          ot.fecha_entrega ? new Date(ot.fecha_entrega).toLocaleDateString() : '',
          ot.ultimo_usuario_modificacion || 'N/A'
        ])

        // Combinar todos los datos
        const allData = [
          ...summaryData,
          headers,
          ...tableData
        ]

        // Crear worksheet
        const ws = XLSX.utils.aoa_to_sheet(allData)

        // Configurar anchos de columnas
        const colWidths = [
          { wch: 25 }, // Part Number / N° de OT
          { wch: 20 }, // Estado / Cantidad  
          { wch: 15 }, // Estado Parte
          { wch: 12 }, // Allocated
          { wch: 15 }, // Fecha Solicitud
          { wch: 15 }, // Fecha Entrega
          { wch: 25 }  // Último Usuario
        ]
        ws['!cols'] = colWidths

        // Agregar worksheet al workbook
        XLSX.utils.book_append_sheet(wb, ws, 'OTs Detalle')

        // Generar nombre del archivo
        const fileName = `OTs_${this.modalData.part_number}_${this.modalData.estado_consultado}_${new Date().toISOString().split('T')[0]}.xlsx`

        // Crear el archivo como blob
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([wbout], { type: 'application/octet-stream' })
        
        // Crear enlace de descarga
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName
        link.style.display = 'none'
        
        // Agregar al DOM y hacer clic
        document.body.appendChild(link)
        link.click()
        
        // Mostrar mensaje inmediato de descarga iniciada
        this.$bvToast.toast('Descarga de archivo iniciada. Revisa tu carpeta de descargas.', {
          title: 'Descarga Iniciada',
          variant: 'info',
          solid: true,
          autoHideDelay: 4000
        })
        
        // Limpiar recursos después de un momento
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.exportingExcel = false
        }, 1000)
        
      } catch (error) {
        console.error('Error al exportar Excel:', error)
        this.exportingExcel = false
        this.$bvToast.toast('Error al generar el archivo Excel', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },
    
    closeModal() {
      this.showModal = false
    },
    
    handleClose() {
      // Limpiar datos al cerrar
      this.modalData = null
      this.allModalOts = []
      this.hasMoreOts = false
      this.loadingMoreOts = false
      this.currentOtPage = 1
      this.exportingExcel = false
      this.modalLoading = false
      
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

// Modal teletransportado a body: el wrapper portalled recibe el scope id
// y expone el id del modal (#parts-modal___BV_modal_outer_ / .modal#parts-modal)
::v-deep [id^='parts-modal'] {
  .modal-dialog {
    max-width: 400px;
  }

  .modal-backdrop {
    background-color: $samtek-grey;
    opacity: 0.5;
  }

  .modal-content {
    background-color: #fff;
    border: none;
    border-radius: 8px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    padding: 20px;
  }

  .modal-header {
    background-color: #fff;
    border-bottom: none;
    padding: 0;
  }

  .modal-title {
    color: $samtek-black;
    width: 100%;
    margin: 0;
  }

  .close {
    color: $samtek-grey;
    text-shadow: none;
    opacity: 1;
    font-size: 20px;
    padding: 0;
    margin-left: 12px;

    &:hover,
    &:focus {
      color: $danger-strong;
      opacity: 1;
    }
  }

  .modal-body {
    padding: 16px 0 0 0;
  }

  .modal-footer {
    border-top: 1px solid $table-head-bg;
    padding: 16px 0 0 0;
  }

  .modal-footer .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    padding: 0 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
  }

  .btn-export {
    color: $samtek-black !important;
    background-color: #fff;
    border: 1px solid $samtek-black;

    &:hover,
    &:focus,
    &:active {
      color: $samtek-black !important;
      background-color: #fff;
      border-color: $samtek-black;
    }

    .b-icon {
      color: $samtek-black;
      font-size: 16px;
      margin-right: 6px;
    }
  }

  .btn-close-modal {
    color: $samtek-black !important;
    background-color: $samtek-yellow;
    border: 1px solid $samtek-yellow;

    &:hover,
    &:focus,
    &:active {
      color: $samtek-black !important;
      background-color: $samtek-yellow;
      border-color: $samtek-yellow;
    }
  }
}

.modal-part-number {
  font-size: 18px;
  font-weight: 700;
  color: $samtek-black;
  line-height: 1.2;
}

.modal-part-type {
  font-size: 12px;
  font-weight: 400;
  color: $samtek-grey;
  margin-top: 2px;
}

.cargar {
  display: inline-block;
  cursor: pointer;
  padding: 0;
  color: $blue-accent;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.modal-table ::v-deep .table {
  margin-bottom: 0;
  table-layout: fixed;
  width: 100%;

  th,
  td {
    border: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  thead th {
    padding: 8px 0;
    background-color: #fff;
    border-bottom: 1px solid $table-head-bg;
    color: $samtek-grey;
    font-size: 12px;
    font-weight: 700;
    text-align: left !important;
  }

  tbody td {
    height: 40px;
    padding: 0;
    color: $samtek-black;
    font-size: 13px;
  }

  tbody tr {
    border: 0 !important;
  }

  tbody td:first-child {
    font-weight: 700;
  }

  // Cantidad a la derecha, Último movimiento a la izquierda
  th:nth-child(2),
  td:nth-child(2) {
    text-align: right !important;
  }

  th:nth-child(3),
  td:nth-child(3) {
    text-align: left !important;
  }
}

.row-title {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid $table-head-bg;
}

.section-icon {
  margin-right: 8px;
  color: $samtek-black;
  font-size: 16px;
}

.section-title {
  margin: 0;
  color: $samtek-black;
  font-size: 16px;
  font-weight: 700;
}
</style>